<template>
  <div class="container-fluid mt-5">
    <div
      class="d-flex flex-wrap flex-column flex-sm-row mb-3 justify-content-between"
    >
      <div class="">
        <div class="d-flex align-items-center">
          <div class="s-32 font-weight-bold text-head text-black">
            Asset Issues
          </div>
        </div>
        <BackRoute />
      </div>
      <div class="d-flex flex-column flex-sm-row link">
        <el-button
          @click="assetIssueModal"
          :color="primarycolor"
          class="header-btn w-100 mt-3 mt-sm-0"
          round
        >
          New Issue
        </el-button>
      </div>
    </div>
    <div class="row mt-5">
      <div class="container-fluid px-0">
        <div class="col-md-12" v-loading="loading">
          <div v-if="assetIssuesData.length > 0">
            <TableNoExport2
              :data="filteredData"
              :headers="AssetIssuesHeaders"
              @update:searchText="handleSearchTextUpdate"
              :checkMultipleItem="false"
              :filterItem="false"
            >
              <template v-slot:assetCode="{ item }">
                <div class="c-pointer fw-400" @click="openEditModal(item.id)">
                  {{ item.assetCode }}
                </div>
              </template>
              <template v-slot:assetName="{ item }">
                <div class="c-pointer fw-400" @click="openEditModal(item.id)">
                  {{ item.assetName }}
                </div>
              </template>
              <template v-slot:dateOfIssue="{ item }">
                <div class="c-pointer fw-400" @click="openEditModal(item.id)">
                  {{ date(item.dateOfIssue) }}
                </div>
              </template>
              <template v-slot:comment="{ item }">
                <div class="c-pointer fw-400" @click="openEditModal(item.id)">
                  {{ item.comment }}
                </div>
              </template>
              <template v-slot:raisedby="{ item }">
                <div class="c-pointer fw-400" @click="openEditModal(item.id)">
                  {{ item.raisedby }}
                </div>
              </template>

              <template v-slot:status="{ item }">
                <div class="c-pointer fw-400" @click="openEditModal(item.id)">
                  {{ issueStatus[item.status] }}
                </div>
              </template>
              <template v-slot:action="{ item }">
                <el-dropdown trigger="click">
                  <el-icon>
                    <MoreFilled />
                  </el-icon>
                  <template #dropdown>
                    <el-dropdown-menu>
                      <el-dropdown-item @click="openEditModal(item.id)">
                        <div class="text-color">Edit</div>
                      </el-dropdown-item>
                      <el-dropdown-item>
                        <div class="text-color" @click="deleteIssue(item.id)">
                          Delete
                        </div>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </template>
                </el-dropdown>
              </template>
            </TableNoExport2>
          </div>
          <div v-else class="text-center py-5">
            <el-empty description="No asset issues available" />
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      v-model="displayModal"
      :title="null"
      :width="mdAndUp || lgAndUp || xlAndUp ? '50%' : '90%'"
      class="border-radius-8"
      :close-on-click-modal="false"
    >
      <div class="p-4">
        <h5 class="font-weight-600 s-24 text-dak mb-4">
          {{ isEditing ? "Edit Asset Issue" : "New Asset Issue" }}
        </h5>

        <div class="row align-items-center">
          <div class="col-md-3 text-md-right text-left">
            <label class="fw-400 s-16 text-dak">Asset Name</label>
          </div>
          <div class="col-md-9">
            <!-- <el-select-v2
              v-model="form.assetName"
              :options="
                issues.map((i) => ({
                  label: i,
                  value: i,
                }))
              "
              placeholder="Select"
              size="large"
              class="w-100"
            /> -->
            <el-select-v2
              v-model="selectedAssetId"
              @change="setSelectedAsset"
              :options="
                assets.map((i) => ({
                  label: i.name,
                  value: i.id,
                }))
              "
              placeholder="Select"
              size="large"
              class="w-100"
            />
          </div>
        </div>

        <div class="row mt-3 align-items-center">
          <div class="col-md-3 text-md-right text-left">
            <label class="fw-400 s-16 text-dak">Raised by</label>
          </div>
          <div class="col-md-9">
            <div class="row">
              <div class="col-md-5">
                <MembersSearch
                  @memberdetail="issueRaisedContact"
                  :currentMember="raisedByInfo"
                />
                <!-- <el-select-v2
                  v-model="form.personId"
                  :options="
                    users.map((i) => ({
                      label: i,
                      value: i,
                    }))
                  "
                  placeholder="Select"
                  size="large"
                  class="w-100"
                /> -->
              </div>
              <div class="col-md-7">
                <div class="row align-items-center">
                  <div class="col-md-3 text-md-right text-left">
                    <label class="fw-400 s-16 mr-3 text-dak">Date</label>
                  </div>
                  <div class="col-md-9">
                    <el-date-picker
                      v-model="form.dateOfIssue"
                      type="date"
                      format="MM/DD/YYYY"
                      size="large"
                      class="w-100"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-3 align-items-center">
          <div class="col-md-3 text-md-right text-left">
            <label class="fw-400 s-16 text-dak">Status</label>
          </div>
          <div class="col-md-9">
            <el-select-v2
              v-model="selectedStatusId"
              @change="setSelectedStatus"
              :options="
                issueStatus.map((i) => ({
                  label: i,
                  value: i,
                }))
              "
              placeholder="Select"
              size="large"
              class="w-100"
            />
            <!-- <el-select-v2
              v-model="form.status"
              :options="
                issueStatus.map((i) => ({
                  label: i,
                  value: i,
                }))
              "
              placeholder="Select"
              size="large"
              class="w-100"
            /> -->
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-3 text-md-right text-left">
            <label class="fw-400 s-16 text-dak">Comment</label>
          </div>
          <div class="col-md-9">
            <el-input
              v-model="form.comment"
              :rows="5"
              type="textarea"
              class="w-100"
              placeholder="Enter your note here"
            />
          </div>
        </div>
        <div class="row mt-4 justify-content-center align-items-center">
          <div class="col-md-3 text-md-right text-left"></div>
          <div class="col-md-5">
            <el-button
              round
              :color="primarycolor"
              class="w-100 text-white"
              @click="handleSubmit"
            >
              {{ isEditing ? "Update Issue" : "Save & Continue" }}
            </el-button>
            <el-button
              round
              link
              class="w-100 text-dak"
              @click="displayModal = false"
            >
              Close
            </el-button>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script setup>
import { ref, inject, computed, onMounted } from "vue";
import BackRoute from "../../components/backroute/BackRoute.vue";
import deviceBreakpoint from "../../mixins/deviceBreakpoint";
import TableNoExport2 from "../../components/table/TableNoExport2.vue";
import assetService from "../../services/asset/assetServices";
import MembersSearch from "../../components/membership/MembersSearch.vue";
import { ElNotification, ElMessageBox } from "element-plus";
import monthDayYear from "../../services/dates/dateformatter";

const primarycolor = inject("primarycolor");
const { mdAndUp, lgAndUp, xlAndUp, xsOnly } = deviceBreakpoint();

const searchText = ref("");
const selectedAssetId = ref(null);
const selectedAsset = ref({});
const raisedByInfo = ref({});
const selectedStatus = ref({});
const displayModal = ref(false);
const loading = ref(false);
const textHead = ref("All issues");
const assetIssuesData = ref([]); // Will be populated from API
const assets = ref([]);
const isEditing = ref(false);
const currentEditId = ref(null);
const selectedStatusId = ref(null);

const AssetIssuesHeaders = ref([
  { name: "ASSET CODE", value: "assetCode" },
  { name: "ASSET NAME", value: "assetName" },
  { name: "ISSUE DATE", value: "dateOfIssue" },
  { name: "ISSUE DETAILS", value: "comment" },
  { name: "RAISED BY", value: "raisedby" },

  { name: "STATUS", value: "status" },
  { name: "ACTION", value: "action" },
]);

const form = ref({
  assetId: "",
  personId: "",
  dateOfIssue: "",
  status: "",
  comment: "",
});

const issueStatus = ["New", "InProgress", "Fixed", "Abandoned"];

const setSelectedAsset = () => {
  selectedAsset.value = assets.value.find((asset) => {
    return asset.id === selectedAssetId.value;
  });
  form.value.assetId = selectedAsset.value ? selectedAsset.value.id : null;
};
const setSelectedStatus = () => {
  selectedStatus.value = issueStatus.find((status) => {
    return status === selectedStatusId.value;
  });
  form.value.status = selectedStatus.value ? selectedStatus.value : null;
};

const date = (offDate) => {
  return monthDayYear.monthDayYear(offDate);
};

// Open Modal
const assetIssueModal = () => {
  displayModal.value = true;
};

const loadAssets = async () => {
  try {
    const response = await assetService.getAssets();
    assets.value = response; // Adjust mapping if backend structure differs
  } catch (error) {
    console.error("Error fetching assets:", error);
  }
};
loadAssets();
const fetchIssues = async () => {
  loading.value = true;
  try {
    const response = await assetService.getIssues();
    // assetIssuesData.value = response; // Adjust mapping if backend structure differs

    // Merge asset details
    assetIssuesData.value = response.map((issue) => {
      const asset = assets.value.find((a) => a.id === issue.assetId);
      return {
        ...issue,
        assetName: asset ? asset.name : "",
        category: asset ? asset.category : "",
        assetCode: asset ? asset.assetCode : "",
      };
    });
    loading.value = false;
  } catch (error) {
    console.error("Error fetching assets:", error);
    loading.value = false;
  }
};
fetchIssues();
const deleteIssue = async (id) => {
  try {
    await ElMessageBox.confirm(
      "Are you sure you want to proceed?",
      "Confirm delete",
      {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "error",
      }
    );
    await assetService.deleteIssue(id);
    ElNotification({
      type: "success",
      message: "Issue deleted successfully",
    });
    fetchIssues(); // Refresh table after deletion
  } catch (error) {
    if (error !== "cancel") {
      console.error("Error deleting issue:", error);
      ElNotification({
        type: "error",
        message: "Failed to delete issue",
      });
    }
  }
};

const issueRaisedContact = (payload) => {
  form.value.personId = payload.id;

  raisedByInfo.value = payload;
  // console.log(payload, 'hhh');
};

const openEditModal = async (id) => {
  try {
    const response = await assetService.getIssueById(id);
    if (response) {
      form.value = {
        assetId: response.assetId || "",
        personId: response.personId || "",
        dateOfIssue: response.dateOfIssue || "",
        status: response.status ? response.status : "",
        comment: response.comment || "",
      };
      selectedAssetId.value = response.assetId || null;
      selectedStatusId.value = issueStatus[response.status] || null;
      raisedByInfo.value = { id: response.personId, name: response.raisedby }; // optional, depends on MembersSearch

      currentEditId.value = id;
      isEditing.value = true;
      displayModal.value = true;
    }
  } catch (error) {
    console.error("Error fetching issue by ID:", error);
    ElNotification({
      type: "error",
      message: "Failed to load issue details for editing",
    });
  }
};

// Form Submit
const handleSubmit = async () => {
  try {
    if (isEditing.value && currentEditId.value) {
      // Update
      await assetService.updateIssue(currentEditId.value, form.value);
      ElNotification({
        type: "success",
        message: "Issue updated successfully",
      });
    } else {
      // Create new
      await assetService.createIssue(form.value);
      ElNotification({
        type: "success",
        message: "Issue created successfully",
      });
    }

    await fetchIssues(); // Refresh data
    displayModal.value = false;

    // Reset edit mode
    isEditing.value = false;
    currentEditId.value = null;
    resetForm();
  } catch (error) {
    console.error("Error saving issue:", error);
    ElNotification({ type: "error", message: "Failed to save issue" });
  }
};

const resetForm = () => {
  form.value = {
    assetId: "",
    personId: "",
    dateOfIssue: "",
    status: "",
    comment: "",
  };
  selectedAssetId.value = null;
  raisedByInfo.value = {};
};

onMounted(() => {
  fetchIssues();
});

// Search filter
const handleSearchTextUpdate = (newValue) => {
  searchText.value = newValue;
};

const filteredData = computed(() => {
  if (!searchText.value.trim()) return assetIssuesData.value;
  return assetIssuesData.value.filter((item) =>
    Object.values(item)
      .join(" ")
      .toLowerCase()
      .includes(searchText.value.toLowerCase())
  );
});
</script>
